// @flow
import React from 'react';
import Radio from './Radio';

import '../../../static/scss/components/ui/radioList.scss';

type RadioObject = {
  value: string,
  label: string
};

type Props = {
  options: Array<RadioObject>,
  className?: string,
  onChange: string => {},
  chosenValue: string
};

const RadioList = ({
  options,
  chosenValue,
  className = '',
  onChange
}: Props) => (
  <ul className={`c-radioList ${className}`}>
    {options.map(({ value, label }) => (
      <li key={value}>
        <label htmlFor={`radio-list--${value}`}>
          <Radio
            id={`radio-list--${value}`}
            onChange={() => onChange(value)}
            value={value}
            checked={value === chosenValue}
          />
          {label}
        </label>
      </li>
    ))}
  </ul>
);

export default RadioList;
